export const personNameRegex = /^[A-Za-z](?:[A-Za-z\s-]*[A-Za-z])?$/;
export const alphabetSpaceAndHyphen = /[^a-zA-Z\s-]/g;
export const onlyNumAlphabetRegex = /[^A-Za-z0-9]/g;
export const numberOnlyRegex = /^\d+$/;
export const emailRegex = /^[a-zA-Z0-9][a-zA-Z0-9._+-]*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
export const nameWithSpecialCharRegex = /^[a-zA-Z'_,-]+$/;
export const phoneFaxFormat = /^\([1-9]\d{2}\) \d{3}-\d{4}$/;
export const numAlphabetOnlyRegex = /^[A-Za-z0-9]*$/;
export const anyCharacters = /^[!-~]*$/;
export const alphabetRegex = /^[A-Za-z]+( [A-Za-z]+)?$/;
export const regexMBI = /^\d[A-Za-z][A-Za-z0-9]\d[A-Za-z][A-Za-z0-9]\d[A-Za-z][A-Za-z]\d\d$/;
export const timeRegex = /^(0\d|1\d|2[0-3]):(0\d|[1-5]\d)$/;
export const passwordValidationRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>\-_=+[\]\\/;']).{8,64}$/;
export const physicianNameRegex = /,/g;
export const numAlphabetSpaceRegex = /[^a-zA-Z0-9\s]/g;
export const removeSpecialChar = /[^a-zA-Z0-9 ]/g;
export const physicianNameValidationRegex =
  /^\(?[A-Za-z](?:[A-Za-z\s.\-()]*[A-Za-z])?\)?$/;
export const alphabetCityRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
export const eligibilityNameRegex = /^[A-Za-z0-9_\-'.]+( [A-Za-z0-9_\-'.]+)*$/;
export const cityPeriodRegex = /^[A-Za-z]+([ .]+[A-Za-z]+)*$/;
export const allowWithoutAdditionalSpaceFreetextRegex = /^(?! )(?!.* {2})(?!.* $)[\s\S]*$/;